import { Component } from '@angular/core';
import { NavController, Events, LoadingController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../../../../../UI/src/app/shared/authentication/authentication.service';
import { TranslationLoaderService } from '../../../../../../../UI/src/app/shared/translation/translation-loader.service';
import { AuthRequestDTO, OTPRequestDTO } from '../../../../../../../UI/src/app/shared/authentication/otp-request-dto';
import { CandidateProfileComponent } from '../../../candidate-profile/candidate-profile.component';
import { ReviewCandidateProfileComponent } from '../../../review-candidate-profile/review-candidate-profile.component';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { PasswordResetComponent } from '../password-reset/password-reset.component';
import { AuthenticationComponent } from '../../authentication.component';
import { AddResumeComponent } from '../add-resume/add-resume.component';
import { JobService } from '../../../../../../../UI/src/app/shared/job/job.service';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { JobAssessmentComponent } from '../../../job-search/components/job-assessment/job-assessment.component';
import { JobDetailsPage } from '../../../job-search/components/job-details/job-details.component';
import { JobApplyObject } from '../../../../../../../UI/src/app/shared/job/job-apply-object.dto';
import { TranslateService } from '@ngx-translate/core';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { Toast508Service } from '../../../../../providers/toast-508.service';
import { HomeComponent } from '../../../../modules/home/home.component';
import { ValidationService } from '../../../../../../../UI/src/app/shared/validation/validation.service';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';
import { PrivacyPolicyComponent } from "../../../privacy-policy/privacy-policy.component";
import { SettingsService } from '../../../../../../../UI/src/app/shared/settings/settings.service';
import { DocumentUploadComponent } from '../../../../modules/candidate-profile/document-upload/document-upload.component';
import { TimelineComponent } from '../../../../../../src/app/modules/timeline/timeline.component';

@Component({
  selector: 'page-signin',
  templateUrl: 'signin.component.html'
})
export class SigninComponent {
  public isEmail = false;
  public username = "";
  public password = "";
  public useremailId = "";
  public userPhoneNumber = "";
  public loading;
  public requestDTO: OTPRequestDTO;
  public signTranslations: any;
  signInUser: FormGroup;
  alertData: any;
  isJobApply: boolean;
  isPrivacyPolicy = false;
  public navigatedFrom = '';
  public redirectedFrom = '';
  public isValidPhoneNumber = false;
  public isBothEnabled: boolean;
  private careerSiteSettings: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastService: ToastControllerService,
    private profileService: ProfileService,
    private jobService: JobService,
    private resumeService: ResumeService,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    public events: Events,
    public loadingCtrl: LoadingController,
    private translationLoader: TranslationLoaderService,
    private translate: TranslateService,
    private toast508Service: Toast508Service,
    private settingsService: SettingsService
  ) {
    this.signInUser = this.formBuilder.group({
      'email': ['', [Validators.required, ValidationService.emailValidator]],
      'password': ['', Validators.required]
    });
    this.loading = this.loadingCtrl.create({
      duration: 10000
    });
    this.translate.get(['CAREER_INVALID_USER', 'CAREER_APPLIED_SUCCESS', 'CAREER_ALREADY_APPLIED', 'CAREER_FAILED_MESSAGE']).subscribe((obj) => {
      this.signTranslations = obj;
    });
    this.events.publish('showSiteMapNodesPublic', true);
    this.careerSiteSettings = authenticationService.getLoginSettings();
    if (this.careerSiteSettings){
      this.setDefaultLogin(this.careerSiteSettings);
    }
    else {
      this.settingsService.GetLoginSettings().subscribe(
        settings => {
          this.setDefaultLogin(settings);
        });
    }
    if(this.authenticationService.getIdentifier() != "" && this.authenticationService.getIdentifier() !== undefined){
      if(this.isEmail) {
      this.useremailId = this.authenticationService.getIdentifier();
      } else {
        this.userPhoneNumber = this.authenticationService.getIdentifier();
      }
    }
    this.navigatedFrom = navParams.get("navigatedFrom");
    this.isJobApply = navParams.get("isJobApply");
    this.enableDisablePrivacyPolicyLink();
    this.events.subscribe('enableDisablePrivacyPolicyLink', () => {
      this.enableDisablePrivacyPolicyLink();
    });
  }

  ionViewDidLoad() {
  }

  setPhoneNumber(eventData) {
    if (eventData) {
      this.isValidPhoneNumber = true;
      this.userPhoneNumber = eventData;
    } else {
      this.isValidPhoneNumber = false;
    }
  }

  forgotPassword() {
    this.navCtrl.push(PasswordResetComponent, { "isJobApply": this.isJobApply });
  }
  setDefaultLogin(careerSiteSettings: any) {
    this.authenticationService.setLoginType(careerSiteSettings);
    this.isEmail = this.authenticationService.getRegistrationType();
    this.isBothEnabled = this.authenticationService.getLoginType();
    if (this.isEmail) {
      this.useremailId = this.username;
    } else {
      if (this.username) {
        this.isValidPhoneNumber = true;
        this.userPhoneNumber = this.username;
      }
    }
  }
  changeIdentifier(isEmail) {
    this.isEmail = isEmail;
    this.authenticationService.isEmail = isEmail;
    this.authenticationService.isLoginTypeChanged = true;
  }
  validate() {
    this.loading.present();
    const payload = new AuthRequestDTO();
    if (this.isEmail) {
      payload.Username = this.useremailId;
    } else {
      payload.Username = this.userPhoneNumber;
    }
    payload.Password = this.password;
    this.authenticationService.signIn(payload).subscribe((response) => {
      if(!response){
        this.loading.dismiss();
        const alertData = { message: this.signTranslations.CAREER_INVALID_USER, type: 'error' };
        this.toastService.presentToast(alertData);
        this.toast508Service.toFocus();
      }
      else {
      this.redirectedFrom = this.navParams.data["redirectedFrom"];
      window.localStorage.setItem(Storage.AUTH_TOKEN, JSON.parse(response));
      this.translationLoader.checkCultureChange();
      this.loading.dismiss();
        const jobApplyObj: JobApplyObject = this.jobService.getApplyJobObject();
        if (jobApplyObj != null && jobApplyObj.JobId != null && jobApplyObj.LaunchedFrom != null) {
          this.jobService.getJobDetails(jobApplyObj.JobId).subscribe(
            (job) => {
              if (job.isApplied) {
                this.navCtrl.setRoot(CandidateProfileComponent);
              } else {
                if(this.authenticationService.isAppliedwithLinkedIn){
                  this.navCtrl.push(AuthenticationComponent, { "action": "linkedin"});
                } else {
                this.profileService.getProfileData().subscribe((profileResponse) => {
                  const jobApplyObject: JobApplyObject = this.jobService.getApplyJobObject();
                  if (profileResponse[0].resumeType !== 0) {
                    if (jobApplyObject != null && jobApplyObject.JobId != null && this.isJobApply) {
                      this.resumeService.getResumeData().subscribe((resumeDataResponse) => {
                        if (resumeDataResponse.isConfirmed) {
                          this.jobService.getAssessmentIdForRequisition(jobApplyObject.JobId).subscribe((assessmentResponse) => {
                            if (assessmentResponse === 0) {
                              this.profileService.applyJob(jobApplyObject.JobId).subscribe((applyJobResponse) => {
                                if (applyJobResponse > 0) {
                                  // Job Applied
                                  this.authenticationService.isAppliedwithLinkedIn = false;
                                  this.jobService.setSuccessAlert(0);
                                } else if (applyJobResponse === -1) {
                                  // Job Already Applied
                                  this.jobService.setSuccessAlert(1);
                                } else if (applyJobResponse === -50) {
                                  // Job Applied Failure
                                  this.jobService.setSuccessAlert(2);
                                }
                                this.navCtrl.setRoot(CandidateProfileComponent);
                                this.navCtrl.push(JobDetailsPage);
                                this.events.publish('showSiteMapNodes', true);
                              }, (error) => {

                              });
                            } else {
                              this.navCtrl.push(JobAssessmentComponent, { "assessmentId": assessmentResponse, "jobId": jobApplyObject.JobId, "navigatedFrom": this.navigatedFrom, "isAssessment":false });
                              this.events.publish('showSiteMapNodes', true);
                            }
                          }, (error) => {
                            this.alertData = { message: this.signTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
                          });
                        } else {
                          this.resumeService.setResumeAction({ action: 'REVIEW_RESUME', isInititalCreation: false, isJobApply: this.isJobApply, showNavbar: true });
                          this.navCtrl.push(ReviewCandidateProfileComponent);
                          this.events.publish('showSiteMapNodes', true);
                        }
                      }, (error) => {
                        // TODO : Implement alert
                      });
                    } else {
                      this.navCtrl.setRoot(CandidateProfileComponent);
                      this.events.publish('showSiteMapNodes', true);
                    }
                  } else {
                    this.navCtrl.setRoot(CandidateProfileComponent);
                    this.resumeService.setResumeAction({ action: 'CREATE_RESUME', isInititalCreation: true, isJobApply: this.isJobApply });
                    this.navCtrl.push(AddResumeComponent);
                    this.events.publish('showSiteMapNodes', true);
                  }
                }, (error) => {
                this.loading.dismiss();
                const alertData = { message: this.signTranslations.CAREER_INVALID_USER, type: 'error' };
                this.toastService.presentToast(alertData);
                this.toast508Service.toFocus();
              });
              }
            }
          }, (error) => {
            this.loading.dismiss();
            const alertData = { message: this.signTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
            this.toastService.presentToast(alertData);
            this.toast508Service.toFocus();
          });
          }
          else if(this.redirectedFrom == 'documents')
          {
            this.navCtrl.setRoot(DocumentUploadComponent, {'Id': this.navParams.data["documentId"]});
          } else if(this.redirectedFrom == 'timeline'){
            this.navCtrl.setRoot(TimelineComponent);
          } else {
            this.navCtrl.setRoot(CandidateProfileComponent);
          }
        }
        }, (error) => {
          this.loading.dismiss();
          const alertData = { message: this.signTranslations.CAREER_INVALID_USER, type: 'error' };
          this.toastService.presentToast(alertData);
          this.toast508Service.toFocus();
        });
      }

  generateOTP() {
    this.loading.present();
    this.requestDTO = new OTPRequestDTO();
    this.requestDTO.UserIdentifier = this.username;
    this.requestDTO.IsEmail = this.isEmail;
    this.authenticationService.setIdentifier(this.username);
    this.authenticationService.setRegistrationType(this.isEmail);
    this.authenticationService.generateOTP(this.requestDTO).subscribe(
      (response) => {
        this.loading.dismiss();
        this.navCtrl.push(AuthenticationComponent, { "action": "validate" });
      }, (error) => {
        this.loading.dismiss();
      }
    );
  }

  showAlert() {
    const jobApplyStatus = this.jobService.getSuccessAlert();
    if (jobApplyStatus === 0) {
      this.alertData = {
        message: this.signTranslations.CAREER_APPLIED_SUCCESS,
        type: 'success'
      };
      this.jobService.setSuccessAlert(3);
      //this.showApplyButton = false;
    } else if (jobApplyStatus === 1) {
      this.alertData = { message: this.signTranslations.CAREER_ALREADY_APPLIED, type: 'info' };
      this.jobService.setSuccessAlert(3);
      //this.showApplyButton = false;
    } else if (jobApplyStatus === 2) {
      this.alertData = { message: this.signTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
      this.jobService.setSuccessAlert(3);
    } else {
      this.alertData = null;
    }
    if (this.alertData != null)
      this.toastService.presentToast(this.alertData);
    this.toast508Service.toFocus();
  }

  signUp() {
    this.authenticationService.isAppliedwithLinkedIn = false;
    this.navCtrl.push(AuthenticationComponent, { "action": 'request' });
  }

  onCancel() {
    if (this.navCtrl.length() > 1) {
      this.navCtrl.pop();
    }
    else {
      this.navCtrl.setRoot(HomeComponent);
    }
  }


  enableDisablePrivacyPolicyLink() {
    this.translate.get(['CAREER_PRIVACY_POLICY_CONTENT_TEXT'])
      .subscribe((obj) => {
        // if the policy content is not equal to '-' enable the link
        if (obj.CAREER_PRIVACY_POLICY_CONTENT_TEXT !== '-') {
          this.isPrivacyPolicy = true;
        } else {
          this.isPrivacyPolicy = false;
        }
      });
  }

  openPrivacyPolicy() {
    this.navCtrl.push(PrivacyPolicyComponent);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/components/signin/signin.component.ts